/**
 * Strip surrounding markdown code fences (e.g. ```json, ```jsonc, ```) from a string.
 * Accepts any fence language tag and tolerates surrounding whitespace.
 */
export function stripMarkdownFences(text: string): string {
  let s = text.trim();
  if (s.startsWith("```")) {
    s = s.replace(/^```[a-zA-Z0-9_-]*\s*/i, "").replace(/\s*```$/, "");
  }
  return s;
}

export function tryRepairTruncatedJson(json: string): string | null {
  try {
    let s = stripMarkdownFences(json);
    s = s.replace(/,\s*$/, "");

    const lastCompleteQuote = s.lastIndexOf('"');
    if (lastCompleteQuote > 0) {
      let quoteCount = 0;
      for (let i = 0; i <= lastCompleteQuote; i++) {
        if (s[i] === '"' && (i === 0 || s[i - 1] !== "\\")) quoteCount++;
      }
      if (quoteCount % 2 !== 0) {
        s += '"';
      }
    }

    s = s.replace(/,?\s*"[^"]*"\s*:\s*$/, "");

    let openBraces = 0;
    let openBrackets = 0;
    let inString = false;
    for (let i = 0; i < s.length; i++) {
      const ch = s[i];
      if (ch === '"' && (i === 0 || s[i - 1] !== "\\")) {
        inString = !inString;
      } else if (!inString) {
        if (ch === "{") openBraces++;
        else if (ch === "}") openBraces--;
        else if (ch === "[") openBrackets++;
        else if (ch === "]") openBrackets--;
      }
    }

    s = s.replace(/,\s*$/, "");
    for (let i = 0; i < openBrackets; i++) s += "]";
    for (let i = 0; i < openBraces; i++) s += "}";

    JSON.parse(s);
    return s;
  } catch {
    return null;
  }
}
